<template>
    <Toast/>
    <div v-if="$can('view','cruise_group')" class="pt-4 pb-2">
        <div class="flex justify-content-between align-items-end">
            <h1 class="my-auto"> Cruise groups </h1>
            <div v-if="$can('add','cruise_group')" class="card p-1">
                <Button data-cy="new_cruise_group_button" class="p-button-text p-button-success" @click="openModal" v-tooltip.bottom="'New Cruise Group'">
                    <i class="pi pi-plus" style="font-size: 1.5rem" ></i>
                </Button>
            </div>
        </div>

        <Dialog data-cy="new_cruise_group_modal" header="New Group" v-model:visible="displayModal" :modal="true" :breakpoints="{'960px': '90vw'}" :style="{width: '50vw'}">
            <form id="form_group_line" @submit.prevent="handleSubmit(!v$.$invalid)" class="p-fluid">
                <div class="container">
                    <div class="row justify-content-center pt-3">
                        <div class="col-10 md:col-12">
                            <div class="p-float-label">
                                <InputText id="name" v-model="v$.name.$model" :class="{'p-invalid':v$.name.$invalid && submitted || group_errors.name}" />
                                <label for="name" :class="{'p-error':v$.name.$invalid && submitted}" > Name* </label>
                                <small v-if="Object.keys(group_errors).length !== 0 && group_errors.name" class="p-error"><span v-for="error in group_errors.name" :key="error">{{error}}<br></span></small>
                            </div>
                            <small v-if="(v$.name.$invalid && submitted) || v$.name.$pending.$response" class="p-error">{{v$.name.required.$message.replace('Value', 'Name')}}</small>
                        </div>
                    </div> 
                </div>
            </form>
            <template #footer>
                <Button data-cy="create_group_button" form="form_group_line" type="submit" label="Submit" class="p-button-raised"/>
            </template>
        </Dialog>
    </div>
</template>

<script>
import Button from 'primevue/button'
import Dialog from 'primevue/dialog'
import InputText from 'primevue/inputtext'
import Toast from 'primevue/toast'
import { required } from '@vuelidate/validators'
import { useVuelidate } from "@vuelidate/core";

export default {
    setup: () => ({ v$: useVuelidate() }),
    components: {
        Dialog,
        Button,
        InputText,
        Toast
    },
    data() {
        return {
            displayModal: false,
            name: '',
            group_errors:{},
            submitted: false,
            showMessage: false,
        }
    },
    computed: {
        get_errors_group: function() {
            return this.$store.getters.get_errors_group
        }
    },
    methods: {
        openModal() {
            this.displayModal = true;
        },
        closeModal() {
            this.displayModal = false;
        },
        async add_group() {
            let groups = { 
                name: this.name,
            }
            await this.$store.dispatch('create_group', groups)
            this.group_errors = this.get_errors_group
            if(Object.keys(this.group_errors).length === 0){
                this.toggleDialog();
                this.name = ''
                return true
            }
            return false
        },
        async handleSubmit(isFormValid) {

            this.submitted = true;
            
            if (!isFormValid) {
                return;
            }

            let res = await this.add_group()
            if (res){
                this.$toast.removeAllGroups();
                this.$toast.add({severity:'success', summary: 'Successful', detail: 'Cruise group added', life: 3000});
            } 
        },
        toggleDialog() {
            this.showMessage = !this.showMessage;
            this.closeModal()

            if(!this.showMessage) {
                this.resetForm();
            }
        },
        resetForm() {
            this.name = '';
            this.submitted = false;
        }
    },
    validations() {
        return {
            name: { required }
        }
    },
};
</script>

<style scoped>
</style>